import { createContext, useContext, useEffect, useState } from 'react';
import { PRIME_CUTS } from './glbCatalog.js';

const GlbCtx = createContext({
  phase: 'ready',
  availability: PRIME_CUTS.map(() => true),
  visibleCuts: PRIME_CUTS
});

async function probeUrl(url) {
  try {
    let res = await fetch(url, { method: 'HEAD' });
    if (res.ok) return true;
    res = await fetch(url, {
      method: 'GET',
      headers: { Range: 'bytes=0-0' }
    });
    return res.ok || res.status === 206;
  } catch {
    return false;
  }
}

export function GlbStatusProvider({ children }) {
  const [state, setState] = useState({
    phase: 'ready',
    availability: PRIME_CUTS.map(() => true),
    visibleCuts: PRIME_CUTS
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const availability = await Promise.all(PRIME_CUTS.map((c) => probeUrl(c.path)));
      if (cancelled) return;
      const allOk = availability.every(Boolean);
      const anyOk = availability.some(Boolean);
      const visibleCuts = PRIME_CUTS.filter((_, i) => availability[i]);
      setState({
        phase: allOk ? 'ready' : anyOk ? 'partial' : 'missing',
        availability,
        visibleCuts
      });
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return <GlbCtx.Provider value={state}>{children}</GlbCtx.Provider>;
}

export function useGlbStatus() {
  return useContext(GlbCtx);
}
